import React from 'react'
import { LayoutStyle, Body } from './style'
import Footer from '../Footer'
import Steps from '../Steps'
import ScrollButton from '../ScrollButton'
import { stopPropagation } from 'utils/common'

const Layout = ({ children, path }) => {
	return (
		<>
			<LayoutStyle className='container'>
				{path !== '/login' && <Steps />}
				<Body path={path}>
					{children}
					<ScrollButton onClick={stopPropagation} />
				</Body>
			</LayoutStyle>
			{path !== '/login' && <Footer />}
		</>
	)
}
export default Layout
